import React from 'react'
import { AdvisorCardsModule } from '../AdvisorCardsModule/AdvisorCardsModule'

/**
 * Content for the Matches tab. Placeholder until the redesigned advisor-cards
 * work lands (tracked separately); will then read its own `advisor_cards_module`
 * slice via useModuleConfig.
 */
export const MatchesPanel = () => {
  return <AdvisorCardsModule />
}
